import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import SurchargeSlipService from "services/SurchargeSlipService";

export const getSurchargeSlipByOrder = createAsyncThunk(
  "surchargeSlip/getByOrder",
  async (orderId, { rejectWithValue }) => {
    try {
      const response = await SurchargeSlipService.getByOrder(orderId);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  surchargeSlipList: [],
};

export const surchargeSlipSlice = createSlice({
  name: "surchargeSlip",
  initialState,
  reducers: {
    clearSurchargeSlipList: (state) => {
      state.surchargeSlipList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSurchargeSlipByOrder.pending, (state) => { state.loading = true; })
      .addCase(getSurchargeSlipByOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.surchargeSlipList = action.payload;
      })
      .addCase(getSurchargeSlipByOrder.rejected, (state) => { state.loading = false; });
  },
});

export const { clearSurchargeSlipList } = surchargeSlipSlice.actions;

export default surchargeSlipSlice.reducer;